import React, { forwardRef } from 'react';
import { styled, SvgIcon } from '@teko/ui';
import { space } from 'styled-system';
import { NavBarDropDown } from './NavBarDropDown.es.js';
import { getTrackingData } from '@teko/tracking';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledNavBarWithSearchBox = styled.div`
  display: flex;
  height: 3.5rem;
  background: #fff;
`;
const Left = styled.div`
  min-width: 3.5rem;
  height: 3.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Right = styled.div`
  min-width: 3.5rem;
  height: 3.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
`;
const Center = styled.div(space, `
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
`);
const SearchBox = styled.input`
  width: 100%;
  height: 2.25rem;
  padding-left: 2rem;
  padding-right: 2rem;
  border: 1px solid #e0e0e0;
  border-radius: 0.5rem;
  outline: none;
`;
const SearchIcon = styled(SvgIcon)`
  position: absolute;
  left: 10px;
  top: 0;
  bottom: 0;
  z-index: 1;
  margin: auto;
`;
const CloseIconWrapper = styled.div`
  position: absolute;
  right: 4px;
  top: 0;
  bottom: 0;
  z-index: 1;
  margin: auto;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const NavBarWithSearchBox = forwardRef((_a, ref) => {
  var _b = _a, {
    placeholder,
    right,
    goBack,
    clickSearchBox,
    onKeyUp,
    onChange,
    keyword,
    clickClearInput,
    dropdownItems = []
  } = _b, props = __objRest(_b, [
    "placeholder",
    "right",
    "goBack",
    "clickSearchBox",
    "onKeyUp",
    "onChange",
    "keyword",
    "clickClearInput",
    "dropdownItems"
  ]);
  return /* @__PURE__ */ React.createElement(StyledNavBarWithSearchBox, __spreadValues({}, props), goBack && /* @__PURE__ */ React.createElement(Left, {
    onClick: goBack
  }, /* @__PURE__ */ React.createElement(SvgIcon, {
    name: "chevron-back",
    size: 24,
    color: "#333"
  })), /* @__PURE__ */ React.createElement(Center, __spreadValues({
    marginLeft: !goBack ? "16px" : "0px",
    marginRight: !right ? "16px" : "0px"
  }, getTrackingData({
    isTrackContent: true,
    regionName: "headerBar",
    contentName: "searchBox",
    target: "searchProduct",
    payload: JSON.stringify(__spreadValues({
      searchKeyword: keyword
    }, typeof window !== "undefined" ? { href: window.location.href, url: window.location.href } : {}))
  })), /* @__PURE__ */ React.createElement(SearchIcon, {
    name: "search",
    size: 16
  }), /* @__PURE__ */ React.createElement(SearchBox, {
    ref,
    onKeyUp,
    onClick: clickSearchBox,
    placeholder,
    onChange,
    value: keyword
  }), keyword && clickClearInput && /* @__PURE__ */ React.createElement(CloseIconWrapper, {
    onClick: () => {
      clickClearInput();
    }
  }, /* @__PURE__ */ React.createElement(SvgIcon, {
    name: "circle-close",
    size: 16
  }))), (right || !!dropdownItems.length) && /* @__PURE__ */ React.createElement(Right, null, right, !!dropdownItems.length && /* @__PURE__ */ React.createElement(NavBarDropDown, {
    padding: "8px",
    items: dropdownItems
  })));
});
NavBarWithSearchBox.displayName = "NavBarWithSearchBox";

export { NavBarWithSearchBox };
